import React, {Fragment, useEffect, useState} from 'react'
import {Button, Form, Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'


import {useFormik} from 'formik'
import {configuracionFormAction17, obtenerComboMotivoDescuento, obtenerSolicitudDescuentos, postActualizarSocitud} from '../../../../store/actions/solicitud-descuento-modal'
import {obtenerSocitudDescuento} from '../../../../store/actions/carta-cia-tercero-acttion'
import Acciones from './acciones'
// import Acciones from './acciones'
import RecobroGestionado from './recobroGestionado'
import { validationSchemas } from '../../../../common/validation-Schemas-descuento-modal'
import {LoadingComponent}from 'recupero-comunes'
import { limpiarRefAction } from '../../../../store/actions/proceso-judicial-action'
import Grilla from './grilla'
import { isValidParam } from '../../../../common/Formatos';

const SolicitudDescuentoModal = ({showSolicitud, handleCloseSolicitud}) => {
    const [loading, setLoading]=useState(false)
    const [montoPropuestoNoFormat,setMontoPropuestoNoFormat ]=useState('')
    const [montoNetoCompara,setMontoNetoCompara ]=useState('')
    const [showToast, setShowToast] = useState(false);
    const handleCloseToast = () => setShowToast(false)
    const handleShowToast = () => setShowToast(true) 
    const data_recepciona = useSelector((state) => state.recepcionaCasoReducer)
    const {llaves} = data_recepciona
    const data_proceso_extrajudicial = useSelector((state) => state.procesoExtrajudicialReducer)
    const {datosGestionImplicado} = data_proceso_extrajudicial
    const data_modal_cia = useSelector(
      (state) => state.modalCartaCiaTerceroReducer
    )
    const {
      
      montosInformados
    } = data_modal_cia
    const dispatch = useDispatch()
    const data_solicitud_modal = useSelector(
        (state) => state.solicitudDescuentoReducer
      )
      const { loadingDescuento} =
      data_solicitud_modal
      useEffect(()=>{
        if(llaves){
            let query3 = Buffer.from(
                JSON.stringify({ "idCaso": llaves && llaves["idCaso"], "idImplicado": llaves && llaves["idImplicado"] })
              ).toString('base64')
              dispatch(obtenerSocitudDescuento(query3))
            }
      },[dispatch,llaves])

    const formik = useFormik({
        initialValues: {
            "idCaso": "",
            "idImplicadoCaso": "",
            "idOrganizacion": "",
            "codMoneda": "",
            "montoCosto":"",
            "porcRecobro":"",
            "montoRecobro":"",
            "porcPropuesto": "",
            "montoPropuesto": "",
            "codMotivoSolicitud": "",
            "comentario": "",
            "idUsuario": ""
        },
        validationSchema: validationSchemas(montoNetoCompara),
        onSubmit: (formData) => {
            const dataForm = {
                ...formData
            }
            setLoading(true)
            dataForm['idCaso'] = llaves && llaves['idCaso']
            dataForm['idImplicadoCaso'] = llaves && llaves['idImplicado']
            dataForm['idOrganizacion'] = llaves && llaves['idOrgCaso']
            dataForm['idUsuario'] = llaves && llaves['idUsuario']
            dataForm['codMoneda'] =  montosInformados && montosInformados.montosInformados[0]['CodMoneda'] !== undefined && montosInformados.montosInformados[0]['CodMoneda'] !== null && montosInformados.montosInformados[0]['CodMoneda'] !== '' ? montosInformados.montosInformados[0]['CodMoneda'] : ''
            dataForm['montoPropuesto'] = montoPropuestoNoFormat

            dataForm['montoCosto'] = isValidParam(montosInformados && montosInformados.montosInformados[0]['MontoCosto']) ? montosInformados.montosInformados[0]['MontoCosto'] : ''
            dataForm['porcRecobro'] = isValidParam(montosInformados && montosInformados.montosInformados[0]['PorConvenido']) ? montosInformados.montosInformados[0]['PorConvenido'] : ''
            dataForm['montoRecobro'] = isValidParam(montosInformados && montosInformados.montosInformados[0]['MontoRecobro']) ? montosInformados.montosInformados[0]['MontoRecobro'] : ''

            if(formData.file){
                getBase64(formData.file).then((base64data) => { 
                    const fileData=base64data.split(',')[1]
                    let data = { ...dataForm, "filename": formData.file.name, "mimetype": formData.file.type, "base64data": fileData };
            
                    dispatch(postActualizarSocitud(data))
                    .then(()=>{
                        dispatch(limpiarRefAction(true))
                    }).then(()=>setLoading(false)) 
                    .then(()=>handleShowToast())               
                })
            }else{
                dispatch(postActualizarSocitud(dataForm)).then(()=>{
                    setLoading(false)           
                    handleShowToast()
                    }
                )
            }
        }
    })
    return (
        <>
        <LoadingComponent show={loading}/>
            <Modal show={showSolicitud}
                onHide={handleCloseSolicitud}
                size='xl'>
                <Form onSubmit={
                    formik.handleSubmit
                }>

                    <RecobroGestionado formik={formik} setMontoPropuestoNoFormat={setMontoPropuestoNoFormat}
                    setMontoNetoCompara={setMontoNetoCompara}
                    showToast={showToast}
                    setShowToast={setShowToast}
                    handleCloseSolicitud={handleCloseSolicitud}
                    />
                    
                    <Acciones handleCloseSolicitud={handleCloseSolicitud}/>
                </Form>
            </Modal>
        </>
    )
}

export default SolicitudDescuentoModal
const getBase64 = (file) => {
    return new Promise(resolve => {
        let reader = new FileReader();
        // Convert the file to base64 text
        reader.readAsDataURL(file);
        reader.onload = () => {
            resolve(reader.result);
        };
    });
  };